import React, { useState } from 'react';
import api from '../../utils/api';

const BulkMessaging = () => {
	const [numbers, setNumbers] = useState('');
	const [sending, setSending] = useState(false);
	const [result, setResult] = useState(null);

	// Approved WhatsApp message template: sme_bootcamp
	const flowId = '974225291459045';
	const bodyText = '*DIGITAL TRANSFORMATION BOOTCAMP*\nA one-day, hands-on workshop for Kenyan SMEs—learn practical tools, secure your business, and apply AI the same day.\n\n*Our Speakers*\n1. *Dr. Bright Gameli, PhD*- Cybersecurity Expert & Thought Leader\n2. *Nyandia Gachago, ACIM*- Marketing Strategist & Digital Transformation Advocate\n3. *Edgar Temba*- Business Systems Expert & CTO. Meira Africa\n\n*Event Details*\n*Date:* Thursday, 18 September 2025\n*Time:* 8:00 AM – 5:00 PM\n*Venue:* Rift Valley Sports Club, Nakuru\n*Fee:* KSh 3,500 _(includes Materials, Tea & Lunch)_\n\nBring: Laptop or Smartphone _(Recommended)_';
	const footerText = 'Click the button to register directly on WhatsApp';
	const buttonText = 'Register via WhatsApp';

	const sendFlow = async () => {
		const recipients = numbers
			.split(/\s|,|\n|;+/)
			.map((n) => n.trim())
			.filter(Boolean);
		if (recipients.length === 0) return;
		setSending(true);
		try {
			const r = await api.post('/schools/whatsapp/send-flow', {
				recipients,
				flowId,
				bodyText,
				footerText,
				buttonText,
				navigateScreen: 'RECOMMEND',
			});
			setResult(r.data);
		} catch (e) {
			setResult({ error: e.details?.error || e.message });
		} finally {
			setSending(false);
		}
	};

	return (
		<div className="container mx-auto px-4 py-6">
			<h2 className="text-xl font-semibold mb-4">Bulk Messaging - WhatsApp Flow</h2>
			<div className="bg-white rounded-lg shadow-soft p-4 space-y-3">
				<textarea className="form-textarea w-full h-40" placeholder="Enter phone numbers separated by comma or newline (e.g., 2547XXXXXXXX)" value={numbers} onChange={(e) => setNumbers(e.target.value)} />
				<button className="btn-primary" onClick={sendFlow} disabled={sending}>{sending ? 'Sending...' : 'Send Flow'}</button>
				{result && (
					<pre className="bg-gray-50 p-3 rounded text-sm overflow-auto max-h-64">{JSON.stringify(result, null, 2)}</pre>
				)}
			</div>
		</div>
	);
};

export default BulkMessaging;


